import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import ListadoVentas from "./ListadoVentas";
import "./VentasAdmin.css";
import Permiso from "../../router/Permiso";
import { Plus, Upload } from "lucide-react";
import { useNavigate } from "react-router-dom";
import ImportarVenta from "./ImportarVenta";
import ListadoAvancesVentas from "./ListadoAvancesVentas";

const VentasAdmin = ({ token, user }) => {
  const [tab, setTab] = useState("listado");
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [mostrarImportar, setMostrarImportar] = useState(false);
  const [debeRecargar, setDebeRecargar] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (debeRecargar) {
      setRefreshTrigger((prev) => prev + 1);
      setDebeRecargar(false);
    }
  }, [debeRecargar]);

  const handleOpenNewVenta = () => {
    navigate("/admin/ventas/registrar");
  };

  const renderTab = () => {
    switch (tab) {
      case "listado":
        return <ListadoVentas token={token} refreshTrigger={refreshTrigger} />;
      case "avances":
        return <ListadoAvancesVentas token={token} refreshTrigger={refreshTrigger} />;
      default:
        return null;
    }
  };

  return (
    <div className="ventas-admin-content">
      <div className="ventas-admin-header">
        <div className="ventas-admin-header-row">
          <div>
            <div className="ventas-admin-title">Ventas</div>
            <div className="ventas-admin-subtitle">
              Gestión profesional de ventas
            </div>
          </div>
          <div className="usuarios-admin-actions">
            <Permiso permiso="create_venta" negacion="lead_create_sale">
              <button
                className="btn-nuevo-usuario"
                onClick={handleOpenNewVenta}
              >
                <Plus size={18} style={{ marginRight: "6px" }} /> Nuevo
              </button>
            </Permiso>
            <Permiso permiso="import_sale">
              <button
                className="btn-nuevo-importar"
                onClick={() => setMostrarImportar(true)}
              >
                <Upload size={18} style={{ marginRight: "6px" }} />
                Importar
              </button>
              {mostrarImportar && (
                <ImportarVenta
                  onClose={() => setMostrarImportar(false)}
                  onSuccess={() => setDebeRecargar(true)}
                  token={token}
                />
              )}
            </Permiso>
          </div>
        </div>
        <div className="ventas-admin-tabs">
          <button
            className={tab === "listado" ? "active" : ""}
            onClick={() => setTab("listado")}
          >
            Listado de Ventas
          </button>

          <Permiso permiso="view_ventas_no_registrada">
            <button
              className={tab === "avances" ? "active" : ""}
              onClick={() => setTab("avances")}
            >
              Ventas no registrada
            </button>
          </Permiso>
        </div>
      </div>
      <div className="ventas-admin-tab-content">{renderTab()}</div>
    </div>
  );
};

VentasAdmin.propTypes = {
  token: PropTypes.string,
  user: PropTypes.object,
};

export default VentasAdmin;
